const FA_DIGITS = "۰۱۲۳۴۵۶۷۸۹";

export const faNum = (n) => Number(n || 0).toLocaleString("fa-IR");

export const faDigits = (s) => String(s).replace(/\d/g, (d) => FA_DIGITS[d]);

export const toEnDigits = (s) =>
  String(s).replace(/[۰-۹]/g, (d) => String(FA_DIGITS.indexOf(d)));

export const parseNum = (s) => {
  const v = parseFloat(toEnDigits(s).replace(/[,٬\s]/g, ""));
  return Number.isFinite(v) ? v : 0;
};

export const faDateTime = (iso) => {
  if (!iso) return "هنوز ثبت نشده";
  try {
    return new Intl.DateTimeFormat("fa-IR", {
      dateStyle: "medium",
      timeStyle: "short",
      timeZone: "Asia/Tehran",
    }).format(new Date(iso));
  } catch {
    return "هنوز ثبت نشده";
  }
};
